<template>
  <el-container style="height:100%;">
    <el-header
      style="height:35px;padding:0px;background-color:aliceblue;border: 0px solid #d1dbe5;border-top-width:1px"
    >
      <el-breadcrumb class="header-bread">
        <el-breadcrumb-item>画布参数</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main style="padding:5px;height:100%">
      <el-card
        class="box-card"
        style="padding:0px;height:99.8%;"
        body-style="padding:3px;"
      >
        <lt-ui-form contendPadding="0px" style="border-width:0px;">
          <el-form
            ref="refFormGroup"
            :inline="false"
            :model="form"
            :inline-message="true"
            label-width="60px"
          >
            <el-row>
              <el-col>
                <el-form-item label="网格" prop="grid">
                  <el-checkbox v-model="form.grid">网格</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="宽(mm)" prop="width">
                  <el-input v-model="form.width">
                    <el-button
                      slot="prepend"
                      icon="icon icon-minus green"
                      @click="handleWDesc"
                    ></el-button>
                    <el-button
                      slot="append"
                      icon="icon icon-plus green"
                      @click="handleWIncrese"
                    ></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="高(mm)" prop="height">
                  <el-input v-model="form.height">
                    <el-button
                      slot="prepend"
                      icon="icon icon-minus green"
                      @click="handleHDesc"
                    ></el-button>
                    <el-button
                      slot="append"
                      icon="icon icon-plus green"
                      @click="handleHIncrese"
                    ></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="背景色" prop="bgColor">
                  <el-color-picker
                    v-model="form.bgColor"
                    size="mini"
                  ></el-color-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="背景图片" prop="bgImage">
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img
                      alt
                      v-if="form.imageUrl"
                      :src="form.imageUrl"
                      class="avatar"
                      style="width:20px;height:20px"
                    />
                    <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </lt-ui-form>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
export default {
  components: {},
  props: {
    formData: {
      type: Object,
      default() {
        return null;
      }
    },
    porperEvent: Object
  },
  watch: {
    form: {
      handler: function(newVal, oldVal) {
        var propertyData = {
          data: newVal,
          type: "grid"
        };
        this.porperEvent.$emit("porpertyChange", propertyData);
      },
      deep: true
    }
  },
  data() {
    return {
      form: {
        grid: true, //是否显示网格
        size: 10,
        width: 100,
        height: 70,
        bgColor: "#FFFFFF",
        scale: 1,
        imageUrl: "" //背景图片
      },
      imageUrl: "" //背景图片路径
    };
  },
  methods: {
    beforeAvatarUpload(file) {
      //文件上传检查
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      //文件上传成功
      this.form.imageUrl = URL.createObjectURL(file.raw);
    },
    handleChange: function() {
      //网格大小改变事件
    },
    handleDesc() {
      if (this.form.grid > 1) {
        this.form.grid--;
      }
    },
    handleIncrese() {
      thid.form.grid++;
    },
    handleWDesc() {
      if (this.form.width > 1) {
        this.form.width--;
      }
    },
    handleWIncrese() {
      this.form.width++;
    },
    handleHDesc() {
      if (this.form.height > 1) {
        this.form.height--;
      }
    },
    handleHIncrese() {
      this.form.height++;
    }
  },
  created() {},
  beforeMount() {}
};
</script>

<style scoped>
.header-bread {
  margin-top: 8px;
  margin-left: 10px;
  font-size: 20px;
  font-weight: bold;
}
</style>
